export default __webpack_public_path__ + "static/return-calculator-pattern-5e1756afc6961bff03dc813ac8ddb559.png";